export default "__VITE_PUBLIC_ASSET__a03ab031__"